import { getWindow } from '@jira/ssr__browser-globals/src/getWindow.tsx';

export const getWRMStats = (): unknown => {
	const wrmStats = getWindow()?.__WRM_INTERNAL_STATS__ ?? {};

	return { wrmStats };
};
